const txteng18 = [
  ["Как ты добираешься до работы?", "How do you get to work?"],
  [
    "Я прибыл в аэропорт в пять часов.",
    "I got to the airport at five o'clock.",
  ],
  [
    "Скажи мне, как добраться до вокзала отсюда?",
    "Can you tell me how to get to the train station from here?",
  ],
  ["Я обычно встаю в семь часов", "I usually get up at seven o'clock."],
  ["Во сколько ты встаешь?", "What time do you get up?"],
  [
    "Майкл ладит с Полом, но не ладит с его босом.",
    "Michael gets along with Paul, but he doesn't get along with his boss.",
  ],
  ["Я дружу со всеми", "I get along with everyone."],
  ["Я не лажу с ним", "I don't get along with him"],
  ["Они стали знакомиться поближе", "They start to get to know each other"],
  [
    "Они поняли, что они не ладят совсем",
    "They realize that they don't get along at all",
  ],
  ["Я хочу избавиться от старой машины", "I want to get rid of my old car."],
  ["сесть в автобус", "get on the bus"],
  ["Давай выйдем на следующей остановке", "Let's get off at the next stop."],
  ["садись в машину.", "Get in the car."],
  ["Можете выйти из моей машины,", "Can you just get out of my car?"],
  [
    "Я устаю и начинаю хотеть есть.",
    "I'm getting tired and I'm getting hungry.",
  ],
];

export default txteng18;
